
import Vue from 'vue';
import Button from '@/components/Button/index.vue';
import moment from 'moment';

moment.locale('pt-br');
export default Vue.extend({
  inject: ['getStepDate'],
  components: {
    Button,
  },
  data() {
    return {
      isOpenModal: false,
      isOpenModal2: true,
      isHidden: false,
      msg: '',
      valueApplication: false,
    };
  },
  methods: {
    getModalSecound() {
      this.isOpenModal = true;
      this.isOpenModal2 = false;
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    closeModalSecound() {
      this.isOpenModal = false;
    },
    returnHome() {
      this.$router.push('/produtor/territory');
    },
    formatNumberData(numero, casasDecimais) {
      return parseFloat(numero).toFixed(casasDecimais);
    },
    onNextStep() {
      if (this.msg.indexOf('haverá isenção total no valor da multa indenizatória') !== -1) {
        this.getStepDate.currentStep += 2;
      } else {
        this.getStepDate.currentStep += 1;
        this.valueApplication = true;
      }
    },
    created() {
      if (this.msg.indexOf('O território não possui detecções válidas para participar do programa') !== -1) {
        this.getStepDate.currentStep += 1;
      }
      if (this.msg.indexOf('haverá isenção total no valor da multa indenizatória') !== -1) {
        this.valueApplication = false;
      } else {
        this.valueApplication = true;
      }
    },
  },
});
